/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ZandaHealth API
 * OpenAPI spec version: 1.0
 */

export type AvailabilityType =
  (typeof AvailabilityType)[keyof typeof AvailabilityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvailabilityType = {
  Unspecified: 0,
  Available: 1,
  Class: 2,
} as const;
